import React from 'react';
import { Box, Heading, Text, Image } from '@wix/design-system';
import { useTranslation } from '@wix/wix-i18n-config';
import s from './SitePreview.scss';
import { useSelectedCategory, useStoreName } from '../../../store/appStore';
import { CategoryKey } from '@common/constants/categories';
import { useCategoryImage } from '../hooks/useCategoryImage';
import { CardLayout } from '../../../components/layouts';
import { SiteIframe } from '../components/SiteIframe/SiteIframe';
import { useSiteUrls } from '../api';

export function SitePreview() {
  const { t } = useTranslation();
  const selectedCategory = useSelectedCategory();
  const { image: categoryImage, isLoading: isImageLoading } = useCategoryImage(selectedCategory as CategoryKey);
  const storeName = useStoreName();
  const { data: siteUrl } = useSiteUrls();

  return (
    <Box direction="vertical" height="100%" width="100%" gap={3}>
      <Box className={s.headerTextWrapper} direction="vertical" gap={1}>
        <Heading className={s.title} size="medium">
          {t('site_preview.header.title')}
        </Heading>

        <Text className={s.textDisclaimer}>{t('site_preview.header.subtitle')}</Text>
      </Box>

      <Box align="center" verticalAlign="middle" gap={1} className={s.statusBar}>
        <Box className={s.statusDot} />
        <Text weight="bold" className={s.previewText}>
          {t('LIVE_ON_THE_WEB')}
        </Text>
      </Box>

      {siteUrl ? (
        <CardLayout>
          <SiteIframe storeName={storeName} src={siteUrl} />
        </CardLayout>
      ) : (
        <CardLayout gap={4}>
          <Box direction="vertical">
            <Text className={s.storeName}>{storeName}</Text>
          </Box>

          <Box className={`${s.imageWrapper} ${siteUrl ? s.iframeContainer : ''}`}>
            {isImageLoading ? (
              <Box align="center" verticalAlign="middle" height="100%">
                <Text>{t('LOADING_PREVIEW')}</Text>
              </Box>
            ) : (
              <Image src={categoryImage!} alt="Site Preview" />
            )}
          </Box>
        </CardLayout>
      )}
    </Box>
  );
}
